import http from "../../core/services/http.service";

const TelephoneBidsService = {
  getTelephoneBids(auctionUuid, params = null) {
    return http.get(`/api/v1/telephone-bids/?auction_uuid=${auctionUuid}`, {
      params: {
        ...params,
        expand: 'bidder.customer,bidder.preferred_clerk,bidder.language,lot,clerk'
      }
    });
  },
  createTelephoneBid(data) {
    return http.post('/api/v1/telephone-bids/batch-actions/', data);
  },
  updateTelephoneBid(data) {
    return http.put(`/api/v1/telephone-bids/${data.uuid}/`, data);
  },
  batchUpdateTelephoneBids(data) {
    return http.put(`/api/v1/telephone-bids/`, data);
  },
  batchRemoveTelephoneBid(uuid) {
    return http.delete(`/api/v1/telephone-bids/`, {
      data: {uuid}
    });
  },
  generateAssignClerks(params = null) {
    return http.get(`/api/v1/telephone-bids/assign/`, {
      params: {
        ...params,
        expand: 'bidder.customer,bidder.preferred_clerk,lot,clerk'
      }
    });
  },
  getTelephoneBidsPdfData(params) {
    return http.get(`/api/v1/telephone-bids/pdf-data/`, {params});
  },
};

export default TelephoneBidsService;
